import { Component, ContentChildren, EventEmitter, Input, Output, QueryList } from '@angular/core';
import { CapturumTemplateDirective, SidebarMenuItem } from '@capturum/ui/api';
import { TooltipPositions } from './enums/tooltip-positions.enum';

@Component({
    selector: 'cap-sidebar-menu',
    templateUrl: './sidebar-menu.component.html',
    standalone: false
})
export class CapturumSidebarMenuComponent {
  @Input() public logoUrl: string;
  @Input() public title: string;
  @Input() public expandable: boolean;
  @Input() public collapseIcon: string = 'fas fa-chevron-left';
  @Input() public expandIcon: string = 'fas fa-chevron-right';
  @Input() public homePageUrl: string = `/`;
  @Input() public menus: SidebarMenuItem[];
  @Input() public routerOptions = { exact: false };
  @Input() public isExpanded: boolean = true;
  @Input() public darkLayout = false;
  @Input() public tooltipDisabled: boolean = true;
  @Input() public tooltipPosition: TooltipPositions = TooltipPositions.RIGHT;
  @Output() public onExpand: EventEmitter<boolean> = new EventEmitter<boolean>();
  @ContentChildren(CapturumTemplateDirective) public templates: QueryList<CapturumTemplateDirective>;

  public toggleExpanded(): void {
    if (this.expandable) {
      this.isExpanded = !this.isExpanded;
      this.onExpand.emit(this.isExpanded);
    }
  }
}
